module.exports = __webpack_public_path__ + "static/img/card-themes_off.69fa599c.png";